export function setLang(url: string, lang: string): string {
	if (url.startsWith('mailto:') || url.startsWith('tel:')) {
		return url;
	}

	try {
		const urlObj = new URL(url);
		urlObj.searchParams.set('lang', lang);
		return urlObj.toString();
	}
	catch {
		return url;
	}
}
